import { render, staticRenderFns } from "./AssessmentGroupAssessments.vue?vue&type=template&id=7b4f4835"
import script from "./AssessmentGroupAssessments.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupAssessments.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupAssessments.vue?vue&type=style&index=0&id=7b4f4835&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VListItemContent,VListItemSubtitle,VListItemTitle,VSelect,VSwitch,VTextField})
